import type {
  AdjustmentCategoryLookupItem,
  DeductionPriorityLookupItem,
  DeductionStageLookupItem,
  DeductionValidityLookupItem,
  DeductionValidityRcaLookupItem,
} from "@src/domain/dto/masterData";
import type {
  IMasterDataTenantLookupsRepository,
  LookupListResult,
} from "@src/domain/repositories/masterData";

export class GetMasterDataTenantLookupsUseCase {
  private readonly repository: IMasterDataTenantLookupsRepository;

  constructor(repository: IMasterDataTenantLookupsRepository) {
    this.repository = repository;
  }

  getAdjustmentCategories(
    brandKey: string,
  ): Promise<LookupListResult<AdjustmentCategoryLookupItem>> {
    return this.repository.getAdjustmentCategoriesLookup(brandKey);
  }

  getDeductionPriorities(
    brandKey: string,
  ): Promise<LookupListResult<DeductionPriorityLookupItem>> {
    return this.repository.getDeductionPrioritiesLookup(brandKey);
  }

  getDeductionStages(brandKey: string): Promise<LookupListResult<DeductionStageLookupItem>> {
    return this.repository.getDeductionStagesLookup(brandKey);
  }

  getDeductionValidities(
    brandKey: string,
  ): Promise<LookupListResult<DeductionValidityLookupItem>> {
    return this.repository.getDeductionValiditiesLookup(brandKey);
  }

  getDeductionValidityRcas(
    brandKey: string,
    deductionTypeId?: number | null,
  ): Promise<LookupListResult<DeductionValidityRcaLookupItem>> {
    return this.repository.getDeductionValidityRcasLookup(brandKey, deductionTypeId);
  }
}
